module.exports = __webpack_public_path__ + "static/img/intro_icon6.d2fc9dc5.png";